import React, { Component } from "react"
import LOGOUT_MUTATION from "./LogoutMutation.gql"
import STOP_IMPERSONATING from "./StopImpersonatingMutation.gql"
import { client, publicClient } from "@/services/api/client"
import { getSsoPayload } from "@/services/api"
import UserContext from "./UserContext"

class UserProvider extends Component {
  state = {
    userIsLoggedIn: false,
    sessionIsLoading: true,
  }

  checkLoggedInUser = async () => {
    if (this.state.userIsLoggedIn) return null

    try {
      const { data } = await getSsoPayload()
      this.setUserLoggedIn(data.isUserLoggedIn)
      this.setSessionLoading(false)
    } catch (error) {
      console && console.error(error)
      this.setSessionLoading(false)
    }
  }

  setSessionLoading = sessionIsLoading => {
    this.setState({ sessionIsLoading })
  }

  setUserLoggedIn = userIsLoggedIn => {
    this.setState({ userIsLoggedIn })
  }

  onLogout = async () => {
    try {
      const { data } = await publicClient.mutate({ mutation: LOGOUT_MUTATION })
      const isLoggedOut = data.logout.success

      if (isLoggedOut) {
        this.setUserLoggedIn(false)
      }
    } catch (error) {
      console.log(error)
    }
  }

  onStopImpersonating = async e => {
    e.preventDefault()

    try {
      const { data } = await client.mutate({ mutation: STOP_IMPERSONATING })
      const { success } = data.stopImpersonating

      if (success) {
        window.location = "/recruiter-insights"
      }
    } catch (error) {
      console && console.log(error)
    }
  }

  componentDidMount() {
    this.checkLoggedInUser()
  }

  render() {
    const { sessionIsLoading, userIsLoggedIn } = this.state

    return (
      <UserContext.Provider
        value={{
          sessionIsLoading,
          userIsLoggedIn,
          onLogout: this.onLogout,
          onStopImpersonating: this.onStopImpersonating,
        }}
      >
        {React.Children.only(this.props.children)}
      </UserContext.Provider>
    )
  }
}

export default UserProvider
